export const AUTO_DEACTIVATE_SETTINGS_KEY = 'sloth:autoDeactivateSettings';
export const AUTO_DEACTIVATE_SETTINGS_EVENT = 'sloth:autoDeactivateSettingsChanged';

export const DEFAULT_AUTO_DEACTIVATE_SETTINGS = {
  enabled: false,
  intervalSeconds: 1,
  windowMinutes: 10
};

export const INTERVAL_OPTIONS_SECONDS = [1, 2, 5, 10, 15, 30, 60];
export const WINDOW_OPTIONS_MINUTES = [1, 2, 5, 10, 15, 30, 60];

export const loadAutoDeactivateSettings = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_AUTO_DEACTIVATE_SETTINGS;
  }

  try {
    const storedSettings = window.localStorage.getItem(AUTO_DEACTIVATE_SETTINGS_KEY);
    if (!storedSettings) {
      return DEFAULT_AUTO_DEACTIVATE_SETTINGS;
    }

    return {
      ...DEFAULT_AUTO_DEACTIVATE_SETTINGS,
      ...JSON.parse(storedSettings)
    };
  } catch (error) {
    console.error('Failed to load auto deactivate settings:', error);
    return DEFAULT_AUTO_DEACTIVATE_SETTINGS;
  }
};

export const saveAutoDeactivateSettings = (settings) => {
  const nextSettings = {
    ...DEFAULT_AUTO_DEACTIVATE_SETTINGS,
    ...settings
  };

  window.localStorage.setItem(AUTO_DEACTIVATE_SETTINGS_KEY, JSON.stringify(nextSettings));
  window.dispatchEvent(new Event(AUTO_DEACTIVATE_SETTINGS_EVENT));
  return nextSettings;
};
